var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.84016 0.540416L9.5126 0.210576C9.40951 0.107567 9.27235 0.0508181 9.12577 0.0508181C8.97926 0.0508181 8.84194 0.107567 8.73885 0.210576L5.00224 3.94735L1.26131 0.206429C1.15838 0.10342 1.02107 0.0467529 0.87456 0.0467529C0.728055 0.0467529 0.590655 0.10342 0.487646 0.206429L0.160001 0.534237C-0.0533338 0.747409 -0.0533338 1.09465 0.160001 1.30782L4.61402 5.77786C4.71695 5.88078 4.8541 5.95331 5.00191 5.95331H5.00362C5.1502 5.95331 5.28736 5.8807 5.39029 5.77786L9.84016 1.31993C9.94325 1.21701 9.99984 1.0757 10 0.929199C10 0.782613 9.94325 0.643262 9.84016 0.540416Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ad7d74e99f3f28e4d1b084f420e5226d.svg";
export { ForwardRef as ReactComponent };